/* Souq Waffar: one inline product video at a time, loaded only on explicit tap. */
(() => {
  'use strict';
  if (window.__swInlineCardVideoV1) return;
  window.__swInlineCardVideoV1 = true;

  let active = null;
  let visibilityObserver = null;

  function setLoading(card, text, show) {
    const label = card.querySelector('[data-swiv-loading]');
    if (!label) return;
    if (text) label.textContent = text;
    label.hidden = !show;
  }
  function close(card, focusTrigger = false) {
    if (!card) return;
    const stage = card.querySelector('[data-swiv-stage]');
    const mount = card.querySelector('[data-swiv-mount]');
    const trigger = card.querySelector('[data-swiv-open]');
    if (!stage || !mount) return;
    const video = mount.querySelector('video');
    if (video) {
      video.pause();
      video.removeAttribute('src');
      video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
    }
    const iframe = mount.querySelector('iframe');
    if (iframe) iframe.removeAttribute('src');
    mount.replaceChildren();
    stage.hidden = true;
    trigger?.setAttribute('aria-expanded', 'false');
    setLoading(card, 'جارٍ تحميل الفيديو…', false);
    if (visibilityObserver) visibilityObserver.unobserve(stage);
    if (active === card) active = null;
    if (focusTrigger && trigger) {
      try { trigger.focus({preventScroll: true}); }
      catch (_) { trigger.focus(); }
    }
  }

  function updateSound(card, video) {
    const button = card.querySelector('[data-swiv-sound]');
    const text = card.querySelector('[data-swiv-sound-label]');
    if (!button || !video) return;
    button.hidden = false;
    button.setAttribute('aria-pressed', String(!video.muted));
    const label = video.muted ? 'تشغيل الصوت' : 'كتم الصوت';
    button.setAttribute('aria-label', label);
    if (text) text.textContent = video.muted ? '🔈' : '🔊';
  }

  function start(card) {
    const stage = card.querySelector('[data-swiv-stage]');
    const mount = card.querySelector('[data-swiv-mount]');
    const template = card.querySelector('[data-swiv-template]');
    const trigger = card.querySelector('[data-swiv-open]');
    if (!stage || !mount || !template || !trigger) return;
    if (stage.dataset.swivEventsBound !== '1') {
      ['click', 'pointerdown', 'pointermove', 'pointerup', 'touchstart', 'touchmove'].forEach(type => {
        stage.addEventListener(type, event => event.stopPropagation(), {passive: true});
      });
      stage.dataset.swivEventsBound = '1';
    }
    if (active && active !== card) close(active);
    if (active === card) return;
    const fragment = template.content.cloneNode(true);
    const video = fragment.querySelector('video');
    const iframe = fragment.querySelector('iframe');
    if (!video && !iframe) return;
    active = card;
    stage.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    if (video) {
      video.autoplay = false;
      video.loop = false;
      video.controls = true;
      video.playsInline = true;
      video.muted = true;
      video.preload = 'none';
      video.addEventListener('playing', () => setLoading(card, '', false));
      video.addEventListener('canplay', () => setLoading(card, '', false));
      video.addEventListener('waiting', () => setLoading(card, 'جارٍ تحميل الفيديو…', true));
      video.addEventListener('stalled', () => setLoading(card, 'جارٍ تحميل الفيديو…', true));
      video.addEventListener('error', () => setLoading(card, 'تعذر تشغيل الفيديو. يمكنك العودة للصورة.', true));
      mount.appendChild(fragment);
      updateSound(card, video);
      setLoading(card, 'جارٍ تحميل الفيديو…', true);
      const attempt = video.play();
      if (attempt?.catch) attempt.catch(() => setLoading(card, '', false));
    } else {
      const button = card.querySelector('[data-swiv-sound]');
      if (button) button.hidden = true;
      iframe.loading = 'eager';
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('allow', 'autoplay; fullscreen; encrypted-media; picture-in-picture');
      try {
        const url = new URL(iframe.src, window.location.href);
        if (/^(?:www\.)?(?:youtube\.com|youtube-nocookie\.com|player\.vimeo\.com)$/.test(url.hostname)) {
          url.searchParams.set('autoplay', '1');
          url.searchParams.set('mute', '1');
          url.searchParams.set('muted', '1');
          url.searchParams.set('playsinline', '1');
          iframe.src = url.toString();
        }
      } catch (_) { /* Leave the provider's URL unchanged. */ }
      mount.appendChild(fragment);
    }
    if (visibilityObserver) visibilityObserver.observe(stage);
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-swiv-open], [data-swiv-close], [data-swiv-sound], [data-swiv-fullscreen]');
    if (button) {
      const card = button.closest('[data-swiv]');
      if (!card) return;
      event.preventDefault();
      event.stopPropagation();
      if (button.matches('[data-swiv-open]')) start(card);
      else if (button.matches('[data-swiv-close]')) close(card, true);
      else if (button.matches('[data-swiv-fullscreen]')) {
        const player = card.querySelector('[data-swiv-mount] video, [data-swiv-mount] iframe');
        if (player) {
          if (player.requestFullscreen) {
            const promise = player.requestFullscreen();
            promise?.catch?.(() => {
              if (player instanceof HTMLVideoElement && player.webkitEnterFullscreen) {
                try { player.webkitEnterFullscreen(); } catch (_) {}
              }
            });
          } else if (player instanceof HTMLVideoElement && player.webkitEnterFullscreen) {
            try { player.webkitEnterFullscreen(); } catch (_) {}
          }
        }
      } else {
        const video = card.querySelector('[data-swiv-mount] video');
        if (video) {
          video.muted = !video.muted;
          updateSound(card, video);
        }
      }
    }
  }, true);

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && active) {
      event.preventDefault();
      close(active, true);
    }
  });
  function isFullscreen(card) {
    if (document.fullscreenElement || document.webkitFullscreenElement) return true;
    const video = card?.querySelector('[data-swiv-mount] video');
    return Boolean(video?.webkitDisplayingFullscreen);
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && active && !isFullscreen(active)) close(active);
  });
  window.addEventListener('pagehide', () => {
    if (active) close(active);
  });
  if ('IntersectionObserver' in window) {
    visibilityObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (active && entry.target === active.querySelector('[data-swiv-stage]') &&
          !isFullscreen(active) && (!entry.isIntersecting || entry.intersectionRatio < 0.12)) close(active);
      });
    }, {threshold: [0, 0.12]});
  }
  document.addEventListener('shopify:section:unload', event => {
    if (active && event.target.contains(active)) close(active);
  });
})();